export enum SurveyParticipantsMenuActions {
	Delete = 'Delete',
	Resend = 'Resend',
	Reopen = 'Reopen',
	Reset = 'Reset',
	Export = 'Export',
}
